export enum TrialExtendSource {
  Webapp = 'Web app',
  Email = 'Email',
}
